import Swiper from 'swiper/bundle';

/***********************************/
/*  Swiper carousels on frontpage  */
/***********************************/
const swiperServices = new Swiper( '.swiper-services', {
    // Responsive breakpoints
    breakpoints: {
        320: {
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
        },
        1000: {
            slidesPerView: 2,
            spaceBetween: 24,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
        }
    }
});

const swiperColors = new Swiper( '.swiper-colors', {
    // Responsive breakpoints
    breakpoints: {
        320: {
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
        },
        1000: {
            slidesPerView: 4,
            spaceBetween: 24,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
        }
    }
});

const swiperCases = new Swiper( '.swiper-cases', {
    // Responsive breakpoints

    slidesPerView: 1,
    spaceBetween: 15,

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    
    breakpoints: {
        568: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1000: {
            slidesPerView: 3,
            spaceBetween: 24,
        }
    }
});

const swiperShHero = new Swiper( '.sh-template-hero .swiper-container', {
    // Responsive breakpoints
    slidesPerView: 1,
    spaceBetween: 0,
    noSwiping: true,
    speed: 2000,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
    },
    autoplay: {
        delay: 3500,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
});

const swiperFpHero = new Swiper( '.swiper-container.mm__hero_slider', {
    // Responsive breakpoints
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
});
